import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonInfrastructureAccountOverview, CommonInfrastructureAccountTopics } from "../../CommonComponents/CommonInfrastructureAccountViews";

export const InfrastructureAccountRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.account,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonInfrastructureAccountOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonInfrastructureAccountTopics />;
    },
};
